
































import Vue, { PropType } from 'vue';
import moment from 'moment-timezone';
import CalenderAppointment from '@/assets/icons/CalenderAppointment.vue';
import { AppointmentType, ScheduleApptDetails } from '@/types';
import { formatDateFormat, formatInTimeZone } from '@/util';

export default Vue.extend({
  name: 'AppointmentDetails',
  components: {
    CalenderAppointment
  },
  props: {
    appointmentDetails: {
      type: Object as PropType<ScheduleApptDetails>,
      required: true
    },
    appointmentType: {
      type: Object as PropType<AppointmentType>,
      required: true
    },
    stepNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    formatDuration (): string {
      const totalhours = moment.duration(this.appointmentType.duration, 'minutes').asHours();
      return totalhours > 1 ? `${totalhours} hours` : `${totalhours} hour`;
    }
  },
  methods: {
    formatSlot (slot: Date | string) {
      return formatInTimeZone(slot, 'h:mm a', this.appointmentDetails.timeZone.value);
    },
    formatDate (date: string) {
      const dateStr = date + 'T00:00:00';
      const option: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      };
      return new Intl.DateTimeFormat('en-US', option).format(new Date(dateStr));
    }
  }
});
